var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * InterfaceSearchVisual component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconInterfaceSearchVisual extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.30476 2.60498C2.91855 2.60498 2.60547 2.91806 2.60547 3.30427V6.44332C2.60547 6.85753 2.26968 7.19332 1.85547 7.19332C1.44126 7.19332 1.10547 6.85753 1.10547 6.44332V3.30427C1.10547 2.08963 2.09012 1.10498 3.30476 1.10498H6.44381C6.85802 1.10498 7.19381 1.44077 7.19381 1.85498C7.19381 2.26919 6.85802 2.60498 6.44381 2.60498H3.30476ZM8.07704 13.8075C6.49386 12.2243 6.49386 9.65749 8.07704 8.07431C9.66023 6.49112 12.2271 6.49112 13.8103 8.07431C15.3935 9.65749 15.3935 12.2243 13.8103 13.8075C12.2271 15.3907 9.66023 15.3907 8.07704 13.8075ZM7.01638 7.01364C4.84741 9.18262 4.84741 12.6992 7.01638 14.8682C9.01594 16.8678 12.1608 17.0239 14.3393 15.3367L17.2419 17.8839C17.5532 18.1572 18.0271 18.1262 18.3003 17.8149C18.5735 17.5036 18.5426 17.0297 18.2313 16.7565L15.3933 14.266C17.0231 12.0906 16.849 8.9917 14.8709 7.01364C12.702 4.84467 9.18536 4.84467 7.01638 7.01364ZM17.5569 1.10498C17.1427 1.10498 16.8069 1.44077 16.8069 1.85498C16.8069 2.26919 17.1427 2.60498 17.5569 2.60498H20.696C21.0821 2.60498 21.3952 2.918 21.3952 3.30427V6.44332C21.3952 6.85753 21.731 7.19332 22.1452 7.19332C22.5594 7.19332 22.8952 6.85753 22.8952 6.44332V3.30427C22.8952 2.08969 21.9107 1.10498 20.696 1.10498H17.5569ZM1.85547 16.8071C2.26968 16.8071 2.60547 17.1429 2.60547 17.5571V20.6963C2.60547 21.0825 2.91859 21.3956 3.30476 21.3956H6.44381C6.85802 21.3956 7.19381 21.7314 7.19381 22.1456C7.19381 22.5598 6.85802 22.8956 6.44381 22.8956H3.30476C2.09008 22.8956 1.10547 21.9108 1.10547 20.6963V17.5571C1.10547 17.1429 1.44126 16.8071 1.85547 16.8071ZM22.8952 17.5571C22.8952 17.1429 22.5594 16.8071 22.1452 16.8071C21.731 16.8071 21.3952 17.1429 21.3952 17.5571V20.6963C21.3952 21.0825 21.0821 21.3956 20.696 21.3956H17.5569C17.1427 21.3956 16.8069 21.7314 16.8069 22.1456C16.8069 22.5598 17.1427 22.8956 17.5569 22.8956H20.696C21.9107 22.8956 22.8952 21.9107 22.8952 20.6963V17.5571Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconInterfaceSearchVisual.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconInterfaceSearchVisual.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconInterfaceSearchVisual.prototype, "size", void 0);
if (customElements.get('cat-icon-interface-search-visual') === undefined) {
    customElements.define('cat-icon-interface-search-visual', BlocksIconInterfaceSearchVisual);
}
